import React, { useState } from 'react';
import { Plus, Minus, HelpCircle } from 'lucide-react';

const ServicesFAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "Do I have to commit long-term?",
      answer: "You can start with a short commitment (e.g., monthly) and continue if it works."
    },
    {
      question: "Will you sound like me when replying to people?",
      answer: "Yes. We align on tone and create a simple \"voice guide.\""
    },
    {
      question: "What tools do you work with?",
      answer: "Commonly Gmail/Google Calendar, Notion, Trello, Asana, ClickUp, Slack, and simple Google Sheets. We adapt to your stack."
    },
    {
      question: "Is my information safe?",
      answer: "We operate with discretion and clear access rules. You control permissions."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="services-faq" className="section-padding bg-white">
      <div className="container-center">
        {/* Section Header */}
        <div className="text-center space-y-6 mb-16 animate-slide-up">
          <div className="flex items-center justify-center space-x-3">
            <HelpCircle className="h-8 w-8 text-burnt-orange" />
            <h2 className="font-display text-4xl lg:text-5xl font-bold text-olive-brown">
              Services FAQ
            </h2>
          </div>
        </div>

        {/* FAQ Items */}
        <div className="max-w-4xl mx-auto space-y-6">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-gray-50 rounded-xl overflow-hidden card-shadow animate-slide-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-8 py-6 text-left flex items-center justify-between hover:bg-gray-100 transition-colors duration-200"
                aria-expanded={openIndex === index}
                aria-controls={`services-faq-answer-${index}`}
              >
                <h3 className="text-lg font-semibold text-olive-brown pr-4">
                  Q: {faq.question}
                </h3>
                <div className="flex-shrink-0">
                  {openIndex === index ? (
                    <Minus className="h-5 w-5 text-burnt-orange" />
                  ) : (
                    <Plus className="h-5 w-5 text-burnt-orange" />
                  )}
                </div>
              </button>
              
              <div
                id={`services-faq-answer-${index}`}
                className={`px-8 transition-all duration-300 ease-in-out ${
                  openIndex === index 
                    ? 'pb-6 opacity-100 max-h-screen' 
                    : 'pb-0 opacity-0 max-h-0'
                } overflow-hidden`}
              >
                <p className="text-olive-brown/70 leading-relaxed">
                  A: {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesFAQ;